import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, LinkData, TextInput } from '../types'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class FullWidthOrderBoxConverter extends CmsConverterService<FullWidthOrderBoxData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_title_text?.value
    const altText = formData.st_image_alternative_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      image: {
        ...CmsConverterService.mapImage(formData.st_image_normal_reference, lazyLoad, altText, title),
        pointOfImage: formData.st_image_point_of_picture?.value?.identifier ?? '',
      },
      buttonLeft: {
        blue: formData.st_left_button_blue_style?.value ?? false,
        show: formData.st_left_button_show?.value ?? false,
        ...formData.st_left_button_link ?? defaultLinkData,
      },
      buttonRight: {
        blue: formData.st_right_button_blue_style?.value ?? false,
        show: formData.st_right_button_show?.value ?? false,
        ...formData.st_right_button_link ?? defaultLinkData,
      },
      headline: formData.st_headline ?? defaultTextInput,
      subLine: formData.st_subline ?? defaultTextInput,
      fontColor: formData.st_font_color?.value?.identifier ?? 'black',
    }
  }
}

export const FULL_WIDTH_ORDER_BOX_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, FullWidthOrderBoxData>>(
  'FullWidthOrderBoxComponent')

export interface FullWidthOrderBoxData extends ConvertedComponentData {
  headline: TextInput;
  fontColor: string;
  subLine: TextInput;
  image: FullWithHeaderImageData;
  buttonLeft: FullWidthHeaderButtonData;
  buttonRight: FullWidthHeaderButtonData;
}

export interface FullWidthHeaderButtonData extends LinkData {
  blue: boolean;
  show: boolean;
}

export interface FullWithHeaderImageData extends Image {
  pointOfImage: string;
}
